import type { CoreRequest } from '$api-clients/hooks';

export enum InteractionType {
  listing = 'listing',
  offer = 'offer',
  lease = 'lease',
  referral = 'referral',
  clientGroup = 'clientGroup',
  userTemplate = 'userTemplate',
}

export type InteractionTypeName = `${InteractionType}`;

export type Offer = CoreRequest<'/offers/{offerId}'>['Data'];
export type Listing = CoreRequest<'/listings/{listingId}'>['Data'];

export type Property = NonNullable<Listing['property']>;

type Lease = Extract<
  CoreRequest<'/interactions/{interactionId}'>['Data']['interaction'],
  { type: 'lease' }
>;

export type LeaseRepresentation = Lease['representation'];

export type InteractionContact =
  CoreRequest<'/interactions/{interactionId}/contacts'>['Data'][number];
export type InteractionContacts =
  CoreRequest<'/interactions/{interactionId}/contacts'>['Data'];

export type InteractionContactType = InteractionContact['type'];

export type AgentContact = Extract<InteractionContact, { type: 'agent' }>;
export type ClientContact = Extract<InteractionContact, { type: 'client' }>;
export type TransactionCoordinatorContact = Extract<
  InteractionContact,
  { type: 'transactionCoordinator' }
>;
export type AttorneyContact = Extract<InteractionContact, { type: 'attorney' }>;

export type InteractionDocument =
  CoreRequest<'/interactions/{interactionId}/documents'>['Data']['results'][number];
export type InteractionDocumentsResponse =
  CoreRequest<'/interactions/{interactionId}/documents'>['Data'];

// Single-document detail response (`/documents/{documentId}`) — distinct from
// the list-item `InteractionDocument` above; carries the full page/input data.
export type InteractionDocumentDetail =
  CoreRequest<'/interactions/{interactionId}/documents/{documentId}'>['Data'];

export type InteractionEnvelope =
  CoreRequest<'/interactions/{interactionId}/envelopes'>['Data'][number];
export type InteractionEnvelopes =
  CoreRequest<'/interactions/{interactionId}/envelopes'>['Data'];
export type EnvelopeRecipient = InteractionEnvelope['recipients'][number];
export type EnvelopeDetail =
  CoreRequest<'/interactions/{interactionId}/envelopes/{envelopeId}'>['Data'];

export type InteractionPackage =
  CoreRequest<'/interactions/{interactionId}/packages'>['Data'][number];
export type InteractionPackages =
  CoreRequest<'/interactions/{interactionId}/packages'>['Data'];
